(function($, window, document, undefined) {
    var EditableComboBox = {
        init : function(options, select) {
            var self = this;
            self.selected = '';
            
            //store a reference to the select object
            self.select = select;
            //store a reference to the jquery select object
            self.$select = $(select);
            //override our options with the options passed in
            self.options = $.extend({}, $.fn.editableComboBox.options, options);
            
            if (!!self.options.newItemText) {
                self.options.newItemText = self.options.newItemText.trim();
                
                if (self.options.newItemText.length > 0) {
                    self.$select.prepend('<option class="new-item-option">' + self.options.newItemText + '</option>');
                }
            }
            
            //create the input element to enter new items
            self.$span = $(document.createElement('span'));
            self.$input = $(document.createElement('input'));

            //put the input and the select in the wrapping span element
            self.$select.before(self.$span);
            self.$span.append(self.$input);
            self.$span.append(self.$select);
            self.$span.addClass('editable-combo-span');
            self.$input.addClass('editable-combo-input');
            self.$select.addClass('editable-combo-select');

            //hide the input element by default
            self.$input.css({
                'position' : 'absolute',
                'display' : 'none'
            });

            self.resizeElements();

            self.$select.keydown(self.keyDownHandler);
            self.$select.change(self.changeHandler);
            self.$input.keyup(self.keyUpHandler);
            
            if (self.options.resetOnFocusOut) {
                self.$input.blur(self.blurHandler);
            } else if (self.options.applyOnFocusOut) {
                self.$input.blur(self.applyBlurHandler);
            }
			
			var items = self.$select.find('option');
			
			if (items.length === 1 && $(items[0]).hasClass('new-item-option')) {
				self.selected = self.options.newItemText;
				self.$input.css('display', 'inline');
				if (typeof options.focusOnInit === "undefined" || options.focusOnInit) {
					// by default, or if specified as true, focus to this field on initializing it
					self.$input.val('').focus();
				} else {
					// otherwise, don't do that
					self.$input.val('');
				}
			}
		},
        addNewItem : function(self, inputElement) {
            var value = $(inputElement).val().trim();
            
            if (value !== '') {
                var existingItem = null;
                var options = self.$select.find('option');
                
                for (var index = 0; index < options.length; index++) {
                    var itemText = $(options[index]).text();
                    
                    if (self.options.caseSensitive) {
                        if (itemText.toUpperCase() === value.toUpperCase()) {
                            existingItem = itemText;
                            break;
                        }
                    } else {
                        if (itemText === value) {
                            existingItem = itemText;
                            break;
                        }
                    }
                }
                
                if (existingItem === null) {
                    self.$select.append('<option>' + value + '</option>');
                    
                    if (!self.options.allowMultipleEdits) {
                        $('.new-item-option').remove();
                    } else {
                    	var selectOptions = self.$select.children('option');
                    	                    
                    	if(self.options.sortItems == true){
                    		selectOptions.sort(function(a,b) {
                       	        return a.text.localeCompare(b.text);
                            })
                    	}
                    	                   
                    	self.$select.empty().append( selectOptions );
                    }
	                   
                    self.$select.val(value);
                    self.previouslySelected = value;
                } else {
                    self.$select.val(existingItem);
                    self.previouslySelected = existingItem;
                }
            } else {
                if (!!self.previouslySelected && self.previouslySelected.length > 0) {
                    self.$select.val(self.previouslySelected);
                } else {
                    self.$select[0].selectedIndex = 1;
                }
            }
        },
        keyDownHandler : function(event) {
            var self = $.data($(this)[0], 'editableComboBox');
            self.selected = $(this).val();

            //ignore the arrow keys and enter key
            if (event.keyCode > 36 && event.keyCode < 41  || event.keyCode === 13) {
                return;
            }

            if (self.selected === self.options.newItemText) {
                self.$input.css('display', 'inline');
                self.$input.val('').focus();
            }            
        },
        keyUpHandler : function(event) {
            var self = $.data($(this).parent().find('select')[0], 'editableComboBox');

            if (event.keyCode === 13) {
                //the enter key was pressed so add the new item.
                if (self.selected === self.options.newItemText) {
                    self.addNewItem(self, this);
                }
                
                $(this).hide();
                self.$select.focus();
            } else if (event.keyCode === 27) {
                //the escape key was pressed so return to the last selected item.
                if (!!self.previouslySelected && self.previouslySelected.length > 0) {
                    self.$select.val(self.previouslySelected);
                } else {
                    self.$select[0].selectedIndex = 1;
                }
                
                $(this).hide();
                self.$select.focus();
            }
            
            self.resizeElements();
        },
        changeHandler : function(event) {
            var value = $(this).val();
            var self = $.data($(this)[0], 'editableComboBox');
            
            if (value === self.options.newItemText) {
                if (self.selected !== self.options.newItemText) {
                    self.previouslySelected = self.selected;
                }
                
                self.selected = value;
                self.$input.css('display', 'inline');
                self.$input.css('height', self.$select.outerHeight());
                self.$input.val('').focus();
                self.resizeElements();
            } else {
                self.previouslySelected = value;
                self.selected = value;
            }            
        },
        blurHandler : function(event) {
            var self = $.data($(this).parent().find('select')[0], 'editableComboBox');

            //the escape key was pressed so return to the last selected item.
            if (!!self.previouslySelected && self.previouslySelected.length > 0 && self.previouslySelected !== self.options.newItemText) {
                self.$select.val(self.previouslySelected);
            } else {
                self.$select[0].selectedIndex = 1;
            }
            
            $(this).hide();
            self.$select.focus();
            self.resizeElements();
        },
        applyBlurHandler : function(event) {
            var self = $.data($(this).parent().find('select')[0], 'editableComboBox');

            if (self.selected === self.options.newItemText) {
                self.addNewItem(self, this);
            }
            
            $(this).hide();
            self.$select.focus();
            self.resizeElements();
        },
        resizeElements : function() {
            var self = this;
            var width = self.$select.outerWidth();
            
            self.$span.css('width', width);
            self.$input.css('width', width);
        }
    };
    
    $.fn.editableComboBox = function(options) {
        return this.each(function() {
            if (this.tagName.toLowerCase() === 'select') {
                var editableComboBox = Object.create(EditableComboBox);
                editableComboBox.init(options, this);
                $.data(this, 'editableComboBox', editableComboBox);
            } else {
                $.error('The specified element is not a <select> element.');
            }
        });
    };
    
    $.fn.editableComboBox.options = {
        newItemText : '-- New Item --',
        allowMultipleEdits : true,
        resetOnFocusOut : true,
        applyOnFocusOut : false,
        caseSensitive : false,
        sortItems : false
    };
})(jQuery, window, document);